import $ from 'jquery';

import Section from '../Section';
import Reviews from '../global/Reviews';

// FIXME: make all the jquery relative to `this.element`

export default class Collection extends Section {
    constructor(theme, element, pageLoad) {
        super(theme, element, pageLoad);

        this.review = new Reviews(pageLoad);

        this.loadTagFilter();
        this.loadSort();
        this.mobileSidebar();
    }

    loadTagFilter = () => {
        /* Product Tag Filters - Good for any number of filters on any type of collection pages */
        var collFilters = $('.coll-filter');
        collFilters.on('change', function () {
            var newTags = [];
            collFilters.each(function () {
                var val = $(this).val();
                if (val) {
                    newTags.push(val);
                }
            });
            if (newTags.length) {
                var query = newTags.join('+');
                window.location.href = $('#link-to-tag-generic a').attr('href').replace(/\/tag($|\?)/, '/' + query + '$1');
            } else {
                window.location.href = $('#link-to-collection').val();
            }
        });
    }

    loadSort = () => {
        const queryParams = {};
        if (location.search.length) {
            for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                aKeyValue = aCouples[i].split('=');
                if (aKeyValue.length > 1) {
                    queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                }
            }
        }

        var sort_by = $('#collection-sort-by').val();
        $('#sort-by')
            .val(sort_by)
            .on('change', function() {
                queryParams.sort_by = $(this).val();
                location.search = $.param(queryParams).replace(/\+/g, '%20');
            });
    }

    mobileSidebar = () => {
        $('.collection-sidebar--section h2').on('click', function () {
            var $this = $(this);
            var parent = $this.parent();
            parent.toggleClass('expanded');
        });
    }
}
